import { useModel as _useModel, mergeModels as _mergeModels } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center gap-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]

import { computed } from 'vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { BarChart } from 'echarts/charts';
import {
  TooltipComponent,
  GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import ChartCard from './ChartCard.vue';


export default {
  __name: 'RankingChart',
  props: /*@__PURE__*/_mergeModels({
  title: {
    type: String,
    required: true,
  },
  /**
   * Full sorted ranking rows: { label, count, role? }.
   * Sliced to the current limit inside this component.
   */
  rows: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: [Object, Error, String],
    default: null,
  },
  /**
   * When true, bar colors follow row.role (student/employee).
   * When false, all bars use barColor.
   */
  colorByRole: {
    type: Boolean,
    default: false,
  },
  barColor: {
    type: String,
    default: '#ee6666',
  },
  limitSelectId: {
    type: String,
    required: true,
  },
}, {
    "limit": {
  type: Number,
  default: 10,
},
    "limitModifiers": {},
  }),
  emits: ["update:limit"],
  setup(__props) {

use([
  CanvasRenderer,
  BarChart,
  TooltipComponent,
  GridComponent,
]);

const props = __props;

const limit = _useModel(__props, 'limit');

const chartRows = computed(() => {
  return props.rows.slice(0, limit.value);
});

const chartOption = computed(() => {
  // Reverse slice for horizontal bars so highest ranks appear at the top
  const rows = [...chartRows.value].reverse();

  const seriesData = props.colorByRole
    ? rows.map((item) => ({
      value: item.count,
      itemStyle: {
        color: item.role === 'student' ? '#0284c7' : '#84cc16',
        borderRadius: [0, 2, 2, 0],
      },
    }))
    : rows.map((item) => ({
      value: item.count,
      itemStyle: {
        color: props.barColor,
        borderRadius: [0, 2, 2, 0],
      },
    }));

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
    },
    grid: { left: '3%', right: '8%', top: 10, bottom: 20, containLabel: true },
    xAxis: {
      type: 'value',
      minInterval: 1,
      splitLine: {
        lineStyle: {
          color: '#f1f5f9',
        },
      },
    },
    yAxis: {
      type: 'category',
      data: rows.map((item) => item.label),
      axisLabel: {
        fontSize: 11,
        width: 140,
        overflow: 'truncate',
      },
    },
    series: [
      {
        name: 'Buchungen',
        type: 'bar',
        barMaxWidth: 14,
        data: seriesData,
        label: {
          show: true,
          position: 'right',
          fontSize: 10,
          formatter: '{c}',
        },
        animationDuration: 600,
        animationEasing: 'cubicOut',
      },
    ],
  };
});

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(ChartCard, {
    title: __props.title,
    loading: __props.loading,
    error: __props.error,
    "is-empty": chartRows.value.length === 0
  }, {
    actions: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend-actions"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          for: __props.limitSelectId,
          class: "form-label mb-0 small text-muted"
        }, "Anzahl:", 8 /* PROPS */, _hoisted_2),
        _withDirectives(_createElementVNode("select", {
          id: __props.limitSelectId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((limit).value = $event)),
          class: "form-select form-select-sm",
          style: {"width":"auto"}
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("option", { value: 6 }, " 6 ", -1 /* CACHED */),
          _createElementVNode("option", { value: 10 }, " 10 ", -1 /* CACHED */),
          _createElementVNode("option", { value: 14 }, " 14 ", -1 /* CACHED */),
          _createElementVNode("option", { value: 20 }, " 20 ", -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_3), [
          [
            _vModelSelect,
            limit.value,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(VChart), {
        class: "chart chart-wide",
        option: chartOption.value,
        autoresize: ""
      }, null, 8 /* PROPS */, ["option"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "loading", "error", "is-empty"]))
}
}

}